import { render, staticRenderFns } from "./dadutou.vue?vue&type=template&id=357853a1&scoped=true&"
import script from "./dadutou.vue?vue&type=script&lang=js&"
export * from "./dadutou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357853a1",
  null
  
)

export default component.exports